(function() { window.GUID_7763fce7_cf29_4a98_beb6_49a7b5e2ab48 = { getGuid: function() { return "7763fce7-cf29-4a98-beb6-49a7b5e2ab48"; } }; })();
/** Host-only adapter: the module never knows legacy URL keys or CS.App's history stack. */
(() => {
    let navigationPending = false;
    $(document).on('ajaxnavigating', () => { navigationPending = true; });
    $(document).on('sectionmasterreplaced', () => { navigationPending = false; });
    CS.Ajax.AjaxListener.OnAjaxStateChange((state, options) => {
        if (options.isNavigation && (state === CS.Ajax.AjaxState.Error || state === CS.Ajax.AjaxState.Aborted))
            navigationPending = false;
    });
    document.addEventListener('cs:surface-overview:replace-query', (event) => {
        const owner = event.target;
        if (navigationPending || !(owner === null || owner === void 0 ? void 0 : owner.isConnected))
            return;
        const mount = owner.closest('[data-cs-blazor-component]');
        if (!mount)
            return;
        const parametersElement = Array.from(document.querySelectorAll('[data-cs-blazor-params-for]'))
            .find(element => element.getAttribute('data-cs-blazor-params-for') === mount.id);
        if (!parametersElement)
            return;
        const parameters = JSON.parse(parametersElement.textContent);
        const detail = event.detail;
        if (!parameters.persistFiltersInUrl || parameters.sportEventId !== detail.sportEventId)
            return;
        const current = new URL(window.location.href);
        const eventIds = Array.from(current.searchParams.entries())
            .filter(pair => pair[0].toLowerCase() === 'eventid');
        if (eventIds.length !== 1 || Number(eventIds[0][1]) !== detail.sportEventId)
            return;
        const values = detail.values;
        const ownedKeys = Object.keys(values).map(key => key.toLowerCase());
        ownedKeys.push('filtersstate', 'filtersstateserialized');
        const parts = current.search.substring(1).split('&').filter(part => {
            if (!part)
                return false;
            const key = new URLSearchParams(part).keys().next().value;
            return ownedKeys.indexOf(key === null || key === void 0 ? void 0 : key.toLowerCase()) < 0;
        });
        Object.keys(values).forEach(key => {
            if (values[key] !== null)
                parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(values[key]));
        });
        const newUrl = current.pathname + (parts.length ? '?' + parts.join('&') : '') + current.hash;
        if (!CS.PopState.ReplaceCurrentPageUrl(newUrl))
            return;
        // A remount of this DOM must not replay the original server selection.
        parameters.initialFilters = detail.initialFilters;
        parametersElement.textContent = JSON.stringify(parameters);
        detail.applied = true;
    });
})();

//# sourceMappingURL=cs-surface-overview-url.js.map
